import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Page } from 'src/app/shared/models/paging/page';
import { ReturnResult } from 'src/app/shared/models/return-result';
import { PagedData } from 'src/app/shared/models/paging/paged-data';
import { HttpClient } from '@angular/common/http';
import { RoleModel } from './role.model';

@Injectable({
  providedIn: 'root'
})
export class RoleServiceService {
  baseUrl = environment.apiRole;
  modelChange: Subject<RoleModel> = new Subject<RoleModel>();
  constructor(private http: HttpClient) { }
  getUserPaging(page: Page): Observable<ReturnResult<PagedData<RoleModel>>> {
    return this.http.post<ReturnResult<PagedData<RoleModel>>>(`${this.baseUrl}/get`, page);
  }
  getUserById(id: any): Observable<ReturnResult<RoleModel>> {

    return this.http.get<ReturnResult<RoleModel>>(`${this.baseUrl}/id?id=${id}`);
  }
  saveRole(model: RoleModel): Observable<ReturnResult<RoleModel>> {
    return this.http.post<ReturnResult<RoleModel>>(this.baseUrl, model);
  }
  deleteRole(id: string): Observable<ReturnResult<boolean>> {
    return this.http.delete<ReturnResult<boolean>>(`${this.baseUrl}/${id}`);
  }
  deletesRole(id: number[]): Observable<ReturnResult<boolean>> {
    return this.http.post<ReturnResult<boolean>>(`${this.baseUrl}/delete`, id);
  }
  getAllRoles(): Observable<ReturnResult<RoleModel[]>> {
    return this.http.get<ReturnResult<RoleModel[]>>(`${this.baseUrl}/all`);
  }
}
